import clsx from 'clsx';
import { useRecoilState } from 'recoil';

import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import { isTableOfContentOpenedOnMobileAtom } from '../../../state';

/**
 * Button to toggle the table of contents on desktop,
 * displayed on hover at the top left of the page sheet view.
 */
export function TableOfContentsDesktopToggleButton(props: {
    isOpened: boolean;
    setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
    showToCToggleButton?: boolean;
    kind?: ButtonProps['kind'];
}) {
    const { isOpened, setIsOpened, showToCToggleButton, kind = 'blank' } = props;

    return (
        <div className="fixed z-10 flex h-fit w-[--toc-hover-area-width] justify-center pt-2 max-lg:hidden">
            <Button
                label={isOpened ? 'Hide table of contents' : 'Show table of contents'}
                className={clsx(
                    'opacity-0 transition hover:opacity-100',
                    (!isOpened || showToCToggleButton) && 'opacity-100'
                )}
                kind={kind}
                onPress={() => {
                    setIsOpened((prev) => !prev);
                }}
                leadingIcon={isOpened ? Icon.PanelLeftClose : Icon.PanelLeftOpen}
                iconOnly
                preventFocusOnPress
            />
        </div>
    );
}

/**
 * Button to toggle the table of contents on mobile,
 * displayed in the space header.
 */
export function TableOfContentsMobileToggleButton() {
    const [isOpened, setIsOpened] = useRecoilState(isTableOfContentOpenedOnMobileAtom);

    return (
        <Button
            leadingIcon={Icon.Menu}
            iconOnly
            className="lg:hidden"
            kind="blank"
            label={isOpened ? 'Show table of contents' : 'Hide table of contents'}
            onPress={() => setIsOpened(!isOpened)}
        />
    );
}
